export enum ToastDurationTypeEnum {
  Short = 3000,
  Medium = 5000,
  Long = 8000,
}
